import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { SalesData } from '../types/dashboard.types';

interface SalesChartProps {
  data: SalesData[];
}

export const SalesChart: React.FC<SalesChartProps> = ({ data }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Ventas por Hora</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis 
              dataKey="time" 
              axisLine={false}
              tickLine={false}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              tickFormatter={(value) => `S/ ${value}`}
            />
            <Tooltip
              formatter={(value: number, name: string) => [
                name === 'sales' ? `S/ ${value}` : value,
                name === 'sales' ? 'Ventas' : 'Órdenes'
              ]}
              labelFormatter={(label) => `Hora: ${label}`}
            />
            <Line
              type="monotone"
              dataKey="sales"
              stroke="#F9690D"
              strokeWidth={2}
              dot={{ fill: '#F9690D', strokeWidth: 2, r: 4 }}
              activeDot={{ r: 6 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};